// extracted by mini-css-extract-plugin
export default {"tooltip":"_p-z","sharingV2":"aq-z","sharingIconsV2":"bq-z","links":"cq-z","link":"dq-z","facebookV2":"eq-z","twitterV2":"fq-z","pinterestV2":"gq-z"};